import script from "./SportSections.vue?vue&type=script&setup=true&lang=js"
export * from "./SportSections.vue?vue&type=script&setup=true&lang=js"

import "./SportSections.vue?vue&type=style&index=0&id=49ece102&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49ece102"]])

export default __exports__